export enum VideoStateEnum {
    'Playing' = 'PLAYING',
    'Pause' = 'PAUSE',
    'Interaction' = 'INTERACTION',
    'Ended' = 'ENDED',
    'Buffering' = 'BUFFERING',
    'UserPause' = 'USER_PAUSE'
}
